import App from '../pages/App';
import Calendar from '../pages/Calendar';

const Routes = [
  {
    path: '/',
    component: Calendar,
    exact: true
  },
  {
    path: '/calendar',
    component: Calendar,
    exact: true
  }
];

export default Routes;
